const riot = require('riot');

riot.tag2('atom-switch', '<div class="switch s-full rounded-full cursor-pointer transition f fm {checked: checked}" onclick="{onToggleChecked}"> <div class="inner-button flex-fixed ml5"></div> </div>', 'atom-switch,[data-is="atom-switch"]{display:block;width:35px;height:20px;cursor:pointer;-webkit-user-select:none;user-select:none} atom-switch .switch,[data-is="atom-switch"] .switch{background-color:#B9B9C9} atom-switch .switch.checked,[data-is="atom-switch"] .switch.checked{background-color:#A20019} atom-switch .switch.checked .inner-button,[data-is="atom-switch"] .switch.checked .inner-button{transform:translateX(13px)} atom-switch .inner-button,[data-is="atom-switch"] .inner-button{width:12px;height:12px;background-color:white;border-radius:50%;transition:256ms}', '', function(opts) {
    this.on('mount', () => {
      this.checked = !!this.opts.checked;
      this.update();
    });

    this.onToggleChecked = () => {
      this.checked = !this.checked;
      this.update();

    };

    this.setValue = (flag) => {
      this.checked = flag;
      this.update();
    };

    this.getValue = () => {
      return this.checked;
    };
});